import { DictionaryLanguageList as DictionaryLanguageListDefinition } from "./DictionaryLanguageList";

export const DictionaryLanguageList = DictionaryLanguageListDefinition;
